const RESET_STORE = 'splitSegmentAudioModalScreen/RESET_STORE';
const SET_IS_SHOWING = 'splitSegmentAudioModalScreen/SET_IS_SHOWING';
const SET_IS_PROCESSING = 'splitSegmentAudioModalScreen/SET_IS_PROCESSING';
const SET_IS_SHOWING_CLOSE_CONFIRMATION =
  'splitSegmentAudioModalScreen/SET_IS_SHOWING_CLOSE_CONFIRMATION';
const SET_AUDIO = 'splitSegmentAudioModalScreen/SET_AUDIO';

export default {
  RESET_STORE,
  SET_AUDIO,
  SET_IS_SHOWING,
  SET_IS_PROCESSING,
  SET_IS_SHOWING_CLOSE_CONFIRMATION,
};
